import * as action from "../actions/index";
import { baseUrl } from "./config";

export const getProfessionals = categoryId => async dispatch => {
  try {
    const result = await fetch(
      `${baseUrl}/professionals/category/${categoryId}`
    );

    if (!result.ok) {
      throw { error: true };
    }

    const data = await result.json();
    //console.log(data);
    dispatch(action.fetchProfessionals(data));
  } catch (error) {
    console.log(error);
  }
};

export const getProfessionalsBySubcategory = subcategoryId => async dispatch => {
  try {
    const result = await fetch(
      `${baseUrl}/professionals/subcategory/${subcategoryId}`
    );

    if (!result.ok) {
      throw { error: true };
    }

    const data = await result.json();
    //console.log(data);
    dispatch(action.fetchProfessionals(data));
  } catch (error) {
    console.log(error);
  }
};

export const getProfessionalById = id => async dispatch => {};

export const getProfessionalInfo = async (userId, token) => {
  try {
    const result = await fetch(`${baseUrl}/professionals/${userId}/`, {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (!result.ok) {
      return { error: true };
    }

    const data = await result.json();
    //console.log(data);
    return data;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};
